import {JsonProperty} from '@hyperloris/tyson';

export class Calculate {
  @JsonProperty()
  result: number = undefined;
}
